module.exports = __webpack_public_path__ + "img/w3.dad5c716.svg";